import { useSnackbar } from 'notistack'
import React, { FC, useState } from 'react'
import { MaterialGroupPropsType, MaterialType } from '../../api/appAPI'
import { EnqueueSnackbarType, showMessage } from '../common/Helpers'
import { MaterialChipType } from '../Hardware/HardwareUIBox'
import MaterialGroupUIBox from './MaterialGroupUIBox'

interface IProps {
  materials: MaterialType[]

  addMaterialGroup(
    mGroupProps: MaterialGroupPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): void
  openMaterialDetails(id: number): void
}

const DefineMaterialGroup: FC<IProps> = (props) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [materialsChips, setMaterialsChips] = useState<MaterialChipType[]>([])

  const { enqueueSnackbar } = useSnackbar()

  const handleNameChange = (event: React.ChangeEvent<{ value: string }>) => {
    setName(event.target.value.replace(/['"]/, ''))
  }

  const handleDescriptionChange = (
    event: React.ChangeEvent<{ value: string }>
  ) => {
    setDescription(event.target.value.replace(/['"]/, ''))
  }

  const deleteMaterialsChip = (chip: MaterialChipType) => {
    setMaterialsChips(materialsChips.filter((ch) => ch.id !== chip.id))
  }

  const addMaterialsChip = (chip: MaterialChipType) => {
    setMaterialsChips([...materialsChips, chip])
  }

  const handleCreateClick = () => {
    if (name === '') {
      showMessage(enqueueSnackbar, 'Enter material group name')
      return
    }

    const materialProps = {
      name,
      description,
      materialsIds: materialsChips.map((chip) => chip.id),
      // editable: '1'
    } as MaterialGroupPropsType

    props.addMaterialGroup(materialProps, enqueueSnackbar)

    setName('')
    setDescription('')
    setMaterialsChips([])
  }

  return (
    <MaterialGroupUIBox
      title="New Material Group"
      materials={props.materials}
      name={{
        value: name,
        onChange: handleNameChange,
      }}
      description={{
        value: description,
        onChange: handleDescriptionChange,
      }}
      materialsChips={{
        chips: materialsChips,
        deleteChip: deleteMaterialsChip,
        addChip: addMaterialsChip,
      }}
      button={{
        text: 'Create',
        onClick: handleCreateClick,
      }}
      openMaterialDetails={props.openMaterialDetails}
      // editable
    />
  )
}

export default DefineMaterialGroup
